<div [ngClass]="{'searchopen': open, 'isMobile': isMobile, 'form': type.includes('form-')}" class="position-relative border-primary border lf-font">
  <div [ngClass]="{'border-input': open && (type == 'list' || schools.length > 0 || cities.length > 0)}"
    class="flex-grow-1 d-flex align-items-center ps-2 ps-sm-3 gap-8">

    <mat-chip-listbox *ngIf="showMatChip && (!currentSearch || currentSearch == searchElement)">
      <mat-chip-option (removed)="eraseSearch()" class="text-wrap text_3">
        <span class="text-nowrap text-ellipsis overflow-hidden d-block text-capitalize">{{searchElement}}</span>
        <span class="material-icons-outlined font-16 text-black" matChipRemove>close</span>
      </mat-chip-option>
    </mat-chip-listbox>


    <input (keyup)="doSearch($event)"
      [(ngModel)]="currentSearch"
      (blur)="showMatChip = false;"
      (focusin)="showMatChip = false"
      (focusout)="showMatChip = ((results.length > 0) || (type != 'list' && currentSearch.length > 0)); sendUnknownItem()"
      [ngClass]="{'font-trueno-bold': currentSearch.length > 0, 'input-text' : currentSearch.length === 0,'smaller': showMatChip}"
      class="appearance-none border-0 br-8 subtitle_1 py-3 bg-transparent flex-grow-1"
      placeholder="{{ (showMatChip ? '' : placeholder) | translate }}"
      type="text">


    <button
      (click)="currentSearchResult && currentSearchResult.type != 'metropole' && currentSearchResult.cityGroup && !open ? expandSearchZone() : trigChangeCity(results[0])"
      class="btn btn-primary text-nowrap subtitle_1 ms-auto me-1 p-0 overflow-hidden w-fit-content d-flex align-items-center justify-content-center"
      type="submit">
                <span *ngIf="wantBtn && currentSearchResult && currentSearchResult.type !== 'metropole' && currentSearchResult.cityGroup && currentSearchResult.cityGroup !== currentSearchResult.id && !open; else elseBlock"
                  class="px-2">
                   {{ 'PROCESSES.ACCOMMODATION.SEARCH_ZONE' | translate }}
                </span>
      <ng-template #elseBlock>
        <i
          class="fa fa-search d-flex align-items-center justify-content-center font-20 text-white bg-primary h-100"></i>
      </ng-template>
    </button>

  </div>

  <div #result *ngIf="(schools || cities) && open && (type == 'list' || schools.length > 0 || cities.length > 0)"
       class="result position-absolute border border-primary border-top-0">

    <div class="mb-2 mt-2" *ngIf="cities.length > 0 && type == 'list' || type == 'form-city'">
      <span class="subtitle_1" *ngIf="type == 'list'">{{ 'PROCESSES.ACCOMMODATION.SEARCH_ZONE_CITY' | translate }}</span>
      <div (click)="trigChangeCity(city)" *ngFor="let city of cities; let first = first" [ngClass]="{'first-res': first}"
        class="res d-flex">
        <lf-icon class="d-inline-block result-icon" fillColor="#B5B7BE" height="18px" name="{{city.icon}}"
          width="18px"></lf-icon>
        <div [innerHtml]="colorResult(city.name)" class="name subtitle_2 d-inline-block"></div>
      </div>
    </div>

    <div class="mb-2 mt-2" *ngIf="schools.length > 0 && type == 'list' || type == 'form-school'">
      <span class="subtitle_1" *ngIf="type == 'list'">{{ 'PROCESSES.ACCOMMODATION.SEARCH_ZONE_SCHOOL' | translate }}</span>
      <div (click)="trigChangeCity(school)" *ngFor="let school of schools; let first = first" [ngClass]="{'first-res': first}"
        class="res d-flex">
        <lf-icon class="d-inline-block result-icon" fillColor="#B5B7BE" height="18px" name="{{school.icon}}"
          width="18px"></lf-icon>
        <div [innerHtml]="colorResult(school.name)" class="name subtitle_2 d-inline-block"></div>
      </div>
    </div>

    <span *ngIf="cities.length === 0 && schools.length === 0"
      class="m-2">{{ 'PROCESSES.ACCOMMODATION.SEARCH_ZONE_NO_RESULTS' | translate }}</span>
  </div>
</div>
